module.exports = __webpack_public_path__ + "img/tm.b13d1440.svg";